import { StyleSheet } from 'aphrodite'
import { styleSheet } from './styles'
import mergeObjects from 'utils/mergeObjects'

const dark = {
  sectionLabel: {
    color: '#9da5a2'
  },
  delimeter: {
    borderBottom: `1px solid #c7c7c7`
  },
  label: {
    color: '#cfcfcf'
  },
  value: {
    color: '#cfcfcf'
  },
  download: {
    borderBottom: '1px dashed #fff',
    textDecoration: 'none',
    color: '#cfcfcf'
  }
}

const themes = {
  light: StyleSheet.create(styleSheet),
  dark: StyleSheet.create(mergeObjects(styleSheet, dark))
}

export default themes



// WEBPACK FOOTER //
// ./src/components/FilterMenu/Section/themes.js